import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function OpeningHook() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-navy-light py-20 px-6 md:px-12" data-id="element-77">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto" data-id="element-78">
        <blockquote className="text-xl md:text-2xl italic text-stone-300 leading-relaxed text-center border-l-4 border-teal-accent pl-8 shadow-[-10px_0_15px_-5px_rgba(0,243,255,0.1)]" data-id="element-79">
          You've been to the doctor. You've taken the pills. You've tried the
          supplements, the diets, and the expensive specialists. And yet, the
          symptom keeps coming back. The burning in your stomach, the tightness
          in your chest, or that recurring infection that medical tests can't
          seem to "fix" for good. You feel like your body is a broken machine,
          or worse, like it's betraying you.
        </blockquote>
      </motion.div>
    </section>;
}